'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import GradeTypeConstants from '../constants/GradeTypeConstants';
import ScoreUtil from '../util/ScoreUtil';

var Score = /*#__PURE__*/function (_React$Component) {
  _inherits(Score, _React$Component);

  function Score() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Score);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Score)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getScoreClassName = function (scorePercentage) {
      var gradeType = ScoreUtil.getOverallGradeType(scorePercentage);
      return classNames((gradeType === GradeTypeConstants.GREAT || gradeType === GradeTypeConstants.GOOD) && 'score-container-good', 'score-container', gradeType === GradeTypeConstants.OK && 'score-container-ok', gradeType === GradeTypeConstants.BAD && 'score-container-bad');
    };

    return _this;
  }

  _createClass(Score, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          scorePercentage = _this$props.scorePercentage,
          scoreStyle = _this$props.scoreStyle;
      return /*#__PURE__*/_jsx("div", {
        className: this.getScoreClassName(scorePercentage),
        onClick: onClick,
        style: scoreStyle,
        children: children
      });
    }
  }]);

  return Score;
}(React.Component);

Score.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  scorePercentage: PropTypes.number.isRequired,
  scoreStyle: PropTypes.object
};
export { Score as default };